import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import {
  Nav,
  NavItem,
  NavLink,
  UncontrolledTooltip,
  Dropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu, Modal,
  ModalBody
} from "reactstrap";

import classnames from "classnames";
import { connect, useDispatch, useSelector } from "react-redux";

import { setActiveTab, changeLayoutMode } from "../../redux/actions";
import userImage from "../../../src/user.png"
import { doc, getDoc, onSnapshot, query, collection, where, getDocs, updateDoc } from 'firebase/firestore';
import { db } from '../../helpers/firebaseInitial';
import Skeleton from '@mui/material/Skeleton';

//Import Images
// import logo from "../../assets/images/logo.svg";
import logo from "../../assets/images/small-logo-icon.png";
// import logozaap from "../../assets/images/zapptalk-fav.png";
import logozaap from "../../assets/images/smalllogo.png";

import avatar1 from "../../assets/images/users/avatar-1.jpg";

//i18n
import i18n from "../../i18n";

// falgs
import usFlag from "../../assets/images/flags/us.jpg";
import spain from "../../assets/images/flags/spain.jpg";
import germany from "../../assets/images/flags/germany.jpg";
import italy from "../../assets/images/flags/italy.jpg";
import russia from "../../assets/images/flags/russia.jpg";
import { createSelector } from "reselect";


function LeftSidebarMenu(props) {
  const dispatch = useDispatch();
  const [UserData, setUserData] = useState({});
  const selectLayoutProperties = createSelector(
    (state) => state.Layout,
    (layout) => ({
      layoutMode: layout.layoutMode,
    })
  );

  const GlobalChangeImage = useSelector((state) => state.Layout.ProfileImageChange);
  console.log("hehhehehehehe", GlobalChangeImage)

  const { layoutMode } = useSelector(selectLayoutProperties);

  const mode = layoutMode === "dark" ? "light" : "dark";

  const onChangeLayoutMode = (value) => {
    if (changeLayoutMode) {
      dispatch(changeLayoutMode(value));
    }
  };

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownOpen2, setDropdownOpen2] = useState(false);
  const [dropdownOpenMobile, setDropdownOpenMobile] = useState(false);
  const [badgeCount, setBadgeCount] = useState(0);
  const [LoadingButton, setLoadingButton] = useState(false)
  const [imageLoaded, setImageLoaded] = useState(false);
  const [logoutmodel, setLogoutModel] = useState(false)
  const [UserNameData, setUserNameData] = useState({})
  const [lng, setlng] = useState("English");

  const toggle = () => setDropdownOpen(!dropdownOpen);
  const toggle2 = () => setDropdownOpen2(!dropdownOpen2);
  const toggleMobile = () => setDropdownOpenMobile(!dropdownOpenMobile);

  const UserDataId = JSON.parse(localStorage.getItem("authUser")).id;
  const ActiveDataId = localStorage.getItem("current_user");
  const fallbackImage = userImage;
  const toggleTab = async (tab) => {

    props.setActiveTab(tab);
    //     const q = query(
    //   collection(db, "unreads"),
    //   where("receiverId", "==",String(UserDataId)),
    //   where("isRead", "==", false)
    // );

    // const snapshot = await getDocs(q);

    // snapshot.forEach((docSnap) => {
    //   updateDoc(doc(db, "unreads", docSnap.id), {
    //     isRead: true,
    //   });
    // });
  };





  const activeTab = props.activeTab;

  /* changes language according to clicked language menu item */
  const changeLanguageAction = (lng) => {
    /* set the selected language to i18n */
    i18n.changeLanguage(lng);

    if (lng === "sp") setlng("Spanish");
    else if (lng === "gr") setlng("German");
    else if (lng === "rs") setlng("Russian");
    else if (lng === "it") setlng("Italian");
    else if (lng === "eng") setlng("English");
  };
  const ProfileData = async () => {
    setLoadingButton(true)
    try {
      const user_id = JSON.parse(localStorage.getItem("authUser")).id;
      const response = await axios.get("product/user-profile/", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${JSON.parse(localStorage.getItem("authUser")).token}`,
        }
      });
      const userDoc = doc(db, "users", String(user_id)); // Assuming user data is stored in 'users' collection
      const userSnapshot = await getDoc(userDoc);
      if (userSnapshot.exists()) {

        const userData = userSnapshot.data();
        console.log("Userggggggg", userData);
        setUserNameData(userData)
        // setModalOpen(false);
        // dispatch(changeProfileLayout(userData));
        //  setUserData(userSnapshot.data()); // Set user data
      } else {
        console.log("No such user!");
      }
      console.log("profile--->", response);
      setUserData(response?.data?.data);
    }
    catch (error) {
      console.log(error);
    }
    setLoadingButton(false)
  }


  const UserLogout = () => {
    console.log("logout---->")
    localStorage.removeItem('authUser')
    localStorage.removeItem('chat_device_token')
    localStorage.removeItem('current_user')
  }

    // Update user name when profile image or user info changes
    useEffect(() => {
      ProfileData();
    }, [GlobalChangeImage]);

    useEffect(() => {
      // Set from localStorage immediately, then fetch from API
      const user = JSON.parse(localStorage.getItem("authUser"));
      setUserNameData(prev => ({ ...prev, first_name: user?.name || "User" }));
      ProfileData();
    }, []);

  useEffect(() => {

    ProfileData();
  }, []);


  const profileSrc =
    UserData?.profile_picture === null
      ? fallbackImage
      : GlobalChangeImage?.userImage;


  const openlogoutModel = () => {
    setLogoutModel(!logoutmodel)
  }


  // useEffect(() => {
  //   const fetchCount = async () => {
  //     const count = await getBadgeCount(UserDataId);
  //     setBadgeCount(count);
  //   };

  //   if (UserDataId) {
  //     fetchCount();
  //   }
  // }, [UserDataId]);

  // useEffect(() => {
  //   if (!UserDataId) return;

  //   const userRef = doc(db, 'users', String(UserDataId));

  //   // Set up real-time listener
  //   const unsubscribe = onSnapshot(userRef, (docSnap) => {
  //     if (docSnap.exists()) {
  //       const data = docSnap.data();
  //       setBadgeCount(data.badge_count || 0);
  //     } else {
  //       console.warn('Document does not exist');
  //       setBadgeCount(0);
  //     }
  //   }, (error) => {
  //     console.error('Snapshot error:', error);
  //   });

  //   // Cleanup listener on unmount
  //   return () => unsubscribe();
  // }, [UserDataId]);
  const fetchUnreadBadgeCount = async (receiverId) => {
    const q = query(
      collection(db, "unreads"),
      where("receiverId", "==", receiverId),
      where("isRead", "==", false)
    );

    const snapshot = await getDocs(q);

    // Count how many times each senderId appears
    const senderCount = {};

    snapshot.forEach((doc) => {
      const data = doc.data();
      const sender = data.senderId;

      if (senderCount[sender]) {
        senderCount[sender]++;
      } else {
        senderCount[sender] = 1;
      }
    });

    // Total count of unread messages
    let totalBadgeCount = Object.values(senderCount).reduce((a, b) => a + b, 0);

    return totalBadgeCount;
  };

  useEffect(() => {
    fetchUnreadBadgeCount(String(UserDataId)).then(setBadgeCount);
  }, [UserDataId]);

  // useEffect(() => {
  //   if (!ActiveDataId) return;

  //   const q = query(
  //     collection(db, "unreads"),
  //     where("receiverId", "==", ActiveDataId),
  //     where("isRead", "==", false)
  //   );

  //   const unsubscribe = onSnapshot(q, (snapshot) => {
  //     console.log("📥 Snapshot docs:", snapshot.size);

  //     const senderCount = {};

  //     snapshot.forEach((doc) => {
  //       const data = doc.data();
  //       console.log("📄", doc.id, data);

  //       const sender = data.senderId;
  //       // if (sender) {
  //       //   senderCount[sender] = (senderCount[sender] || 0) + 1;
  //       // }

  //         if (senderCount[sender]) {
  //       senderCount[sender]++;
  //     } else {
  //       senderCount[sender] = 1;
  //     }
  //     });

  //     const totalBadgeCount = Object.values(senderCount).reduce((a, b) => a + b, 0);
  //     setBadgeCount(totalBadgeCount);
  //     console.log("🔔 Unread Badge Count:", totalBadgeCount);
  //   });

  //   return () => unsubscribe();
  // }, [ActiveDataId]);





  return (
    <React.Fragment>
      <div className="side-menu flex-lg-column me-lg-1">
        {/* LOGO */}
        <div className="navbar-brand-box">
          {/* <Link to="/" className="logo logo-dark"> */}
            <span className="logo-sm">
              {/* <img src={logo} alt="logo" height="50" /> */}
              <img src={logozaap} alt="logo" height="50" />

            </span>
          {/* </Link> */}

          {/* <Link to="/" className="logo logo-light"> */}
            {/* <span className="logo-sm">
              <img src={logo} alt="logo" height="30" />
            </span> */}
          {/* </Link> */}
        </div>
        {/* end navbar-brand-box  */}

        {/* Start side-menu nav */}
        {/* <div className="flex-lg-column my-auto"> */}

        <Nav
          className="side-menu-nav nav-pills justify-content-center"
          role="tablist"
        >
           {/* <NavItem id="Notification">
            <NavLink
              id="pills-contacts-tab"
              className={
                classnames({ active: activeTab === "Notification" }) + "  "
              }
              // onClick={() => {
              //   toggleTab("contacts");
              // }}
            >

              <i className={activeTab === "Notification" ? "ri-notification-fill" : "ri-notification-line"}></i>

              <p style={{ fontSize: '11px' }}>Notification</p>
            </NavLink>
          </NavItem> */}

          <NavItem id="Contacts">
            <NavLink
              id="pills-contacts-tab"
              className={
                classnames({ active: activeTab === "contacts" }) + "  "
              }
              onClick={() => {
                toggleTab("contacts");
              }}
            >

              <i className={activeTab === "contacts" ? "ri-contacts-line" : "ri-contacts-line"}></i>

              <p style={{ fontSize: '11px' }}>Contacts</p>
            </NavLink>
          </NavItem>
          <NavItem id="Chats">
            <NavLink
              id="pills-chat-tab"
              className={classnames({ active: activeTab === "chat" })}
              onClick={() => toggleTab("chat")}
              style={{ position: 'relative' }} // Make this container relative
            >
              <i className={activeTab === "chat" ? "ri-message-3-line" : "ri-message-3-line"}></i>

              {badgeCount > 0 && (
                // <span className="notification-badge">{badgeCount}</span>
                <span className="notification-badge"></span>

              )}

              <p style={{ fontSize: '11px' }}>Chats</p>
            </NavLink>
          </NavItem>

          {/* <UncontrolledTooltip target="Chats" placement="top">
              Chats
            </UncontrolledTooltip> */}

          <NavItem id="Groups">
            <NavLink
              id="pills-groups-tab"
              className={
                classnames({ active: activeTab === "group" }) + "  "
              }
              onClick={() => {
                toggleTab("group");
              }}
            >
              {/* <i className="ri-group-line"></i> */}
              {/* <i className="ri-group-fill"></i> */}
              <i className={activeTab === "group" ? "ri-group-line" : "ri-group-line"}></i>
              {console.log("acttttttttt", activeTab)}
              <p style={{ fontSize: '11px' }}>Groups</p>
            </NavLink>
          </NavItem>
          {/* <UncontrolledTooltip target="Groups" placement="top">
              Groups
            </UncontrolledTooltip> */}

         


          {/* <Dropdown
            nav
            isOpen={dropdownOpenMobile}
            toggle={toggleMobile}
            className="profile-user-dropdown d-inline-block d-lg-none dropup"

          >
            <DropdownToggle nav>
              <img
                src={avatar1}
                alt="WMConnect"
                className="profile-user rounded-circles"

              />
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-end">
              <DropdownItem
                onClick={() => {
                  toggleTab("profile");
                }}
              >
                Profile{" "}
                <i className="ri-profile-line float-end text-muted"></i>
              </DropdownItem>
              <DropdownItem
                onClick={() => {
                  toggleTab("settings");
                }}
              >
                Settings{" "}
                <i className="ri-settings-3-line float-end text-muted"></i>
              </DropdownItem>
              <DropdownItem divider />
              <DropdownItem tag={Link} to="/wm/logout">
                Log out{" "}
                <i className="ri-logout-circle-r-line float-end text-muted"></i>
              </DropdownItem>
            </DropdownMenu>
          </Dropdown> */}
        </Nav>
        {/* </div> */}
        {/* end side-menu nav */}


        <div className="flex-lg-column d-none d-lg-block responsive-margin">

          <Nav
            className="side-menu-nav justify-content-center nav"
          >
             {/* <Dropdown
            nav
            isOpen={dropdownOpen2}
            className="btn-group dropup profile-user-dropdown"
            toggle={toggle2}

          >
            <DropdownToggle nav>
              <i className="ri-global-line"></i>
              {/* <i class="ri-global-fill"></i> 

              <p style={{ marginLeft: '-4px', fontSize: '11px' }}>Language</p>
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem
                onClick={() => changeLanguageAction("eng")}
                active={lng === "English"}
              >
                <img src={usFlag} alt="user" className="me-1" height="12" />{" "}
                <span className="align-middle">English</span>
              </DropdownItem>

              <DropdownItem
                onClick={() => changeLanguageAction("sp")}
                active={lng === "Spanish"}
              >
                <img src={spain} alt="user" className="me-1" height="12" />{" "}
                <span className="align-middle">Spanish</span>
              </DropdownItem>

              <DropdownItem
                onClick={() => changeLanguageAction("gr")}
                active={lng === "German"}
              >
                <img src={germany} alt="user" className="me-1" height="12" />{" "}
                <span className="align-middle">German</span>
              </DropdownItem>

              <DropdownItem
                onClick={() => changeLanguageAction("it")}
                active={lng === "Italian"}
              >
                <img src={italy} alt="user" className="me-1" height="12" />{" "}
                <span className="align-middle">Italian</span>
              </DropdownItem>

              <DropdownItem
                onClick={() => changeLanguageAction("rs")}
                active={lng === "Russian"}
              >
                <img src={russia} alt="user" className="me-1" height="12" />{" "}
                <span className="align-middle">Russian </span>
              </DropdownItem>
            </DropdownMenu>
          </Dropdown> */}

            
            {/* <Dropdown
              nav
              isOpen={dropdownOpen}
              className="nav-item"
              toggle={toggle}
            > */}
              {/* <DropdownToggle
                className="nav-link d-flex flex-column align-items-center justify-content-center"
                tag="a"
                style={{ padding: '0.5rem', textAlign: 'center' }}
              > */}


                {/* <div className="user-profile-responsive text-center">



                  {LoadingButton || !imageLoaded ? (
                    <>
                      <Skeleton
                        variant="circular"
                        width={40}
                        height={40}
                        className="user-avatar"
                        style={{ marginBottom: '4px' }}
                      />
                      <Skeleton
                        variant="text"
                        width={60}
                        height={20}
                        className="user-name"
                        style={{ margin: '0 auto' }}
                      />
                    </>
                  ) : null}

                  <img
                    src={profileSrc}
                    alt="User"
                    className="profile-user rounded-circles user-avatar"
                    style={{ display: imageLoaded ? 'block' : 'none' }}
                    onLoad={() => setImageLoaded(true)}
                    onError={() => {
                      setImageLoaded(true); // fallback image still shown
                    }}
                  />
                  {console.log("")}
                  {imageLoaded && (
                    // <p className="user-name">
                    //   {UserData?.first_name?.length > 15
                    //     ? `${UserData?.first_name.slice(0, 15)}...`
                    //     : UserData?.first_name}
                    // </p>
                    <p className="user-name">
                      {UserNameData?.first_name?.length > 15
                        ? `${UserNameData?.first_name.slice(0, 15)}...`
                        : UserNameData?.first_name}
                    </p>
                  )}

                </div> */}
                  {/* <DropdownToggle onClick={() => toggleTab('settings')} nav>
              <i className="ri-settings-3-line float-end text-muted"></i>
           

              <p style={{ marginLeft: '-4px', fontSize: '11px' }}>Settings</p>
            </DropdownToggle> */}

              
              {/* </DropdownToggle> */}

              {/* <DropdownMenu>
                <DropdownItem onClick={() => toggleTab('profile')} className="design-drop">
                  Profile <i className="ri-profile-line float-end text-muted"></i>
                </DropdownItem>
                <DropdownItem onClick={() => toggleTab('settings')} className="design-drop">
                  Settings <i className="ri-settings-3-line float-end text-muted"></i>
                </DropdownItem>
                <DropdownItem
                  id="light-dark"
                  onClick={() => onChangeLayoutMode(mode)}
                  className="design-drop"
                >
                  Mode <i className="ri-sun-line theme-mode-icon float-end text-muted"></i>
                </DropdownItem>
                <DropdownItem divider />
                
                <DropdownItem className="design-drop" onClick={() => openlogoutModel()}>
                  Log out <i className="ri-logout-circle-r-line float-end text-muted"></i>
                </DropdownItem>
              </DropdownMenu> */}
            {/* </Dropdown> */}
            <Dropdown nav isOpen={dropdownOpen} className="nav-item" toggle={toggle}>
  <DropdownToggle
    nav
    tag="a"
    className="nav-link d-flex flex-column align-items-center justify-content-center"
    
    onClick={() => toggleTab("settings")}
    style={{ cursor: "pointer" }}
  >
    {/* <i className="ri-settings-2-line"></i> */}
    {console.log("sctive set---->",activeTab)}
     <i className={activeTab === "settings" ? "ri-settings-2-line" : "ri-settings-2-line"}></i>
    <span className="font-size-10">Settings</span>
  </DropdownToggle>
</Dropdown>
          </Nav>

        </div>
        {/* Side menu user */}

        <Modal
          tabIndex="-1"
          isOpen={logoutmodel}
          // toggle={toggleuserLeavemodal}
          centered
        >
          <ModalBody>
            {/* <div className="modal-overlay"> */}
            {/* <div className="modal-box" style={{marginLeft: "20px"}}> */}
            <h2 className="modal-title">
              Do you want logout ?
            </h2>
            {/* <p className="modal-message">
                   Do you want logout 
                  </p> */}
            <div className="modal-actions">
              <button
                className="cancel-button"
                onClick={() => openlogoutModel()}
              >
                Close
              </button>
              <Link
                to="/logout"
                className="remove-button"
                style={{ backgroundColor: "rgb(15, 90, 148)" }}
                onClick={UserLogout}
              >
                Logout
              </Link>
            </div>
            {/* </div> */}
            {/* </div> */}
          </ModalBody>
        </Modal>
      </div>
    </React.Fragment>
  );
}

const mapStatetoProps = (state) => {
  return {
    ...state.Layout,
  };
};

export default connect(mapStatetoProps, {
  setActiveTab,
})(LeftSidebarMenu);
